import React from "react";
import { Layout } from "../layout";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ROUTES } from "~/const/route";
import { useDispatch } from "react-redux";
import { logoutSpecialist } from "~/redux/modules/specialist/auth";
import { initialize } from "~/redux/modules/specialist/auth";

export const SpecialistFinish: React.VFC = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  // ログアウト
  const onClickLogout = async () => {
    await dispatch(logoutSpecialist());
    history.push(ROUTES.SPECIALIST.LOGOUT);
  };

  // 編集画面に戻る
  const navigateHome = () => {
    dispatch(initialize());
    setTimeout(() => history.push(ROUTES.SPECIALIST.HOME), 100);
  };

  return (
    <Layout>
      <Grid
        className={classes.container}
        container
        alignItems="center"
        justify="center"
      >
        <div>
          <h1 className={classes.h1}>登録完了</h1>
          <p className={classes.p}>
            登録が完了しました。ありがとうございました。
            <br />
            再度情報を編集する場合は、下記ボタンもしくはログイン画面からログイン情報を入力してください。
          </p>
          <Grid container alignItems="center" justify="center">
            <Button
              className={classes.button}
              variant="contained"
              onClick={navigateHome}
            >
              情報を編集する
            </Button>
            <Button
              className={classes.button}
              variant="contained"
              color="secondary"
              onClick={onClickLogout}
            >
              ログアウト
            </Button>
          </Grid>
        </div>
      </Grid>
    </Layout>
  );
};

const useStyles = makeStyles({
  container: {
    minHeight: "calc(100vh - 128px)",
  },
  h1: {
    fontSize: 34,
    fontWeight: "normal",
    margin: 0,
  },
  p: {
    fontSize: 20,
    margin: 0,
    marginTop: 15,
  },
  button: {
    display: "block",
    width: 150,
    marginTop: 70,
    marginRight: 10,
    marginLeft: 10,
  },
});
